import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AcModel } from 'projects/runner/src/app/models/ac.model';
import { RatingstartType, TimerType } from 'projects/runner/src/app/models/acstatus/ac-status.type';
import { CandidateModel } from 'projects/runner/src/app/models/candidate.model';
import { SINGLE_GROUP_UUID } from 'projects/runner/src/app/models/constants';
import { GroupModel } from 'projects/runner/src/app/models/group.model';
import { SlotModel } from 'projects/runner/src/app/models/slot.model';
import { AuthStateService } from 'projects/runner/src/app/services/auth-state.service';
import { DataService } from 'projects/runner/src/app/services/data.service';
import { Subscription } from 'rxjs';
import { ExerciseContainer } from '../../agenda/agenda.component';
import moment, { Moment } from 'moment';

@Component({
  selector: 'app-agenda-exercise-slot',
  templateUrl: './agenda-exercise-slot.component.html',
  styleUrls: ['./agenda-exercise-slot.component.scss']
})
export class AgendaExerciseSlotComponent implements OnInit, OnDestroy {

  @Input() slot: SlotModel = null;
  @Input() candidate: CandidateModel = null;
  @Input() group: GroupModel = null;
  @Input() container: ExerciseContainer = null;
  @Input() index = 0;

  public ac: AcModel = null;
  public acSubscription: Subscription = null;

  constructor(
    private data: DataService,
    private router: Router,
    public auth: AuthStateService,
  ) { }

  ngOnInit(): void {
    this.acSubscription = this.data.ac$.subscribe({
      next: (ac: AcModel) => {
        if (ac !== null) {
          this.ac = ac;
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.acSubscription !== null) {
      this.acSubscription.unsubscribe();
      this.acSubscription = null;
    }
  }

  public isLastSlot(): boolean { // single ac only
    return this.ac.isSingle() && this.slot.id === this.container.slots[this.container.slots.length - 1]?.id;
  }

  public canOpenSlot(): boolean {
    const hash = this.data.getHash(this.slot, this.candidate, this.group);
    return this.auth.canOpenSlot(hash, this.slot, this.group, this.ac?.isWithinObserverOpenableTime());
  }

  public canOpenRating(): boolean {
    return this.auth.canOpenRating(this.group);
  }

  public canControlSlot(): boolean {
    return this.auth.canControlSlot(this.group);
  }

  public openSlot(): void {
    if (this.canOpenSlot()) {
      this.router.navigate(this.getUrl());
    }
  }

  public openRating(): void {
    if (this.canOpenRating()) {
      this.router.navigate(this.getUrl(TimerType.Rating));
    }
  }

  public getStartTime(mode: TimerType = TimerType.Exercise): Moment | null {
    let result: Moment = moment(this.ac.start_time).add(this.slot.calculatedStartTime, 'minutes');
    if (mode === TimerType.Rating && this.slot.rating_start === RatingstartType.End) {
      result.add(this.slot.duration, 'minutes');
    }
    if (this.ac.isGroup() && this.slot.exercise?.isIndividual() && this.index > 0) {
      result.add(this.index * this.slot.exercise.duration, 'minutes');
      result.subtract(this.index * this.slot.exercise.getExerciseGap(), 'minutes');
    }
    return result;
  }

  public dummy(): void {
  }

  private getUrl(mode: TimerType = TimerType.Exercise): Array<string | number> {
    const url: Array<string | number> = [
      'ac',
      mode,
      this.slot?.id,
      this.group?.hash || SINGLE_GROUP_UUID,
    ];
    if (this.candidate) {
      url.push(this.candidate.hashed_id);
    }
    return url;
  }

}
